import { render, staticRenderFns } from "./ViewContractComponent.vue?vue&type=template&id=37eb4d66"
import script from "./ViewContractComponent.vue?vue&type=script&lang=js"
export * from "./ViewContractComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports